import { Component, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { LMFormPanelBase } from './lm-form-panel-base';
import { LMModel } from '@form/model/lm-model';
import {Observer, Observable, of} from 'rxjs';
import {LMRefreshRequest} from "@app/components";

@Component({
  selector: 'lm-form-panel-notfound',
  template: `
    <div *ngIf="activated">
        <p>Unsupported type for composite form tab area</p>
    </div>
  `
})
export class LMFormPanelNotFoundComponent implements LMFormPanelBase {
  @Input() formSpec: LMFormSpec;
  @Input() formOptions: any; // todo: type me
  @Input() layout: any;
  @Input() model: LMModel;
  @Input() specFields: LMSpecFields;
  @Input() activated: boolean
  @Input() needsReload: boolean;
  @Input() panelDataState: LMPanelDataState
  @Input() fromDataView: LMDataView;
  @Input() panelId: string;

  @Output() formPanelContentLoaded = new EventEmitter<any>();

  constructor(private elementRef: ElementRef) { }

  public refresh(request?: LMRefreshRequest): Observable<boolean> {
    return of(true);
  }

  public save(observer: Observer<boolean>) {
    if (observer) {
      observer.next(true);
      observer.complete();
    }
  }

  public isDirty(): boolean {
    return false;
  }

  public getPanelHeight(): number {
    if (this.elementRef) {
      return this.elementRef.nativeElement.offsetHeight;
    }
    return 0;
  }

  saveCompositeComponentState(): void {
    // noop
  }

  clearCompositeComponentState(): void {
    // noop
  }
}
